import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ScheduleService } from 'src/app/services/schedule.service';
import Swal from 'sweetalert2';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-next-pending-appointment',
  templateUrl: './next-pending-appointment.component.html',
  styleUrls: ['../../../../../assets/css/styles.css', './next-pending-appointment.component.css']
})
export class NextPendingAppointmentComponent implements OnInit {

  @Input() data: any = {};
  usuario: any;
  modalActual: string | null = null;

  anularReservaForm: FormGroup;
  cancelReason: any[] = [];

    options_bool: boolean = true;


  constructor(
    private scheduleService: ScheduleService,
    private router: Router,
    private fb: FormBuilder
  ) {
    this.anularReservaForm = this.fb.group({
      paciente: [null, Validators.required],
      id_consulta: [null, Validators.required],
      motivo: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.usuario = new EncriptacionService().getUserInfo();
    this.obtenerMotivosCancelacion();
  }

  obtenerMotivosCancelacion() {
    this.scheduleService.getListarCancelReason("PENDIENTE")
      .then((response: any) => {
        this.cancelReason = response;
      })
      .catch((error: any) => {
        console.error("Error al obtener los motivos:", error);
      });
  }

  abrirModal(tipo: string) {
    this.modalActual = tipo;
    document.body.classList.add("modal-open");

    this.anularReservaForm.patchValue({
      paciente: this.usuario._id,
      id_consulta: this.data.id_consulta
    });
  }

  cerrarModal() {
    this.modalActual = null;
    document.body.classList.remove("modal-open");
  }

  mostrarModalConfirmacion() {
    if (this.anularReservaForm.invalid) {
      Swal.fire({
        icon: 'warning',
        title: 'Atención',
        text: 'Por favor selecciona un motivo de anulación.',
        confirmButtonColor: '#2BABB7'
      });
      return;
    }
    this.modalActual = 'confirmacionFinalPendiente';
  }
  isCanceling = false;

  anularReservaConfirmada() {
    if (this.isCanceling) return; // evita doble click
  this.isCanceling = true;
    const motivo = this.anularReservaForm.value.motivo;
    const pacienteId = this.usuario._id;
    const idConsulta = this.data.id_consulta;

    this.scheduleService.cancelAppointment(idConsulta, pacienteId, motivo, null, null)
      .then(data => {
        this.cerrarModal();
        Swal.fire({
          allowOutsideClick: false,
          html: `<i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i>
                 <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: 48px; text-align: center; color: #171994;">
                     Su reserva pendiente ha sido anulada exitosamente
                 </h1>`,
          showConfirmButton: false
        });

        setTimeout(() => {
          Swal.close();
          this.router.navigateByUrl('/dashboard').then(() => {
            window.location.reload();
          });
        }, 2000);
      })
      .catch(error => {
        console.error("Error al cancelar la reserva:", error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo procesar la anulación. Inténtalo nuevamente.',
          confirmButtonColor: '#2BABB7'
        });
      });
  }

  finishPending() {
    var url = "reserva-pendiente/" + this.data.id_consulta;
    this.router.navigate([url]);
  }
  
}
